import React from 'react';
import { useSelector } from 'react-redux';

import { disclaimerTypeSelector } from 'src/redux/configurator/selectors';
import { disclaimerSelector, showPriceDisclaimerSelector } from 'src/redux/app/selectors';
import { Wrap, MainText, DisclaimerWrapper } from './DisclaimerModal.styled';

const DisclaimerModal = () => {
  const disclaimerType = useSelector(disclaimerTypeSelector);
  const disclaimerInformation = useSelector(disclaimerSelector);
  const isPriceDisclaimer = disclaimerType === 'price-disclaimer';
  const showPriceDisclaimer = useSelector(showPriceDisclaimerSelector);

  // Access the price disclaimer text from the script tag in the layout
  const priceDisclaimerWrapper = document.getElementById('price-disclaimer-wrapper');
  const decodeHTML = html => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
  };
  const priceDisclaimerText = priceDisclaimerWrapper ? decodeHTML(priceDisclaimerWrapper.innerHTML.trim()) : '';

  return (
    <Wrap>
      {!isPriceDisclaimer && (
        <MainText
          dangerouslySetInnerHTML={{
            __html: disclaimerInformation[disclaimerType],
          }}
        ></MainText>
      )}
      {isPriceDisclaimer && showPriceDisclaimer && (
        <DisclaimerWrapper
          dangerouslySetInnerHTML={{
            __html: priceDisclaimerText,
          }}
        ></DisclaimerWrapper>
      )}
    </Wrap>
  );
};

export default DisclaimerModal;
